import { Link } from "react-router-dom";
import { FiHeart, FiShoppingCart, FiTrash2 } from "react-icons/fi";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import "./Wishlist.css";

export default function Wishlist() {
  const { wishlist, toggle } = useWishlist();
  const { dispatch } = useCart();

  const handleAddToCart = (product) => {
    dispatch({ type: "ADD", item: { ...product, size: product.sizes?.[0] || "" } });
  };

  if (wishlist.length === 0)
    return (
      <div className="wishlist-empty">
        <FiHeart size={56} />
        <h2>Your wishlist is empty</h2>
        <p>Save items you love and find them here anytime.</p>
        <Link to="/shop" className="btn-shop">Browse Products</Link>
      </div>
    );

  return (
    <div className="wishlist-page">
      <div className="wishlist-header">
        <h1>My Wishlist</h1>
        <span>{wishlist.length} item{wishlist.length !== 1 ? "s" : ""}</span>
      </div>
      <div className="wishlist-grid">
        {wishlist.map(p => (
          <div key={p.id} className="wishlist-card">
            <Link to={`/product/${p.id}`} className="wishlist-img-wrap">
              <img src={p.image} alt={p.name} />
              {p.badge && <span className={`badge badge-${p.badge.toLowerCase()}`}>{p.badge}</span>}
            </Link>
            <div className="wishlist-info">
              <Link to={`/product/${p.id}`}><h3>{p.name}</h3></Link>
              <p className="wishlist-cat">{p.category}</p>
              <div className="wishlist-price">
                <span className="price">Rs. {Number(p.price).toLocaleString()}</span>
                {p.originalPrice && <span className="original">Rs. {Number(p.originalPrice).toLocaleString()}</span>}
              </div>
              <div className="wishlist-actions">
                <button className="btn-add-cart" onClick={() => handleAddToCart(p)}>
                  <FiShoppingCart /> Add to Cart
                </button>
                <button className="btn-remove" onClick={() => toggle(p)} title="Remove">
                  <FiTrash2 />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
